/**
 * Converts a player name to kebab case for use in external IDs
 */
export function playerNameToKebabCase(playerName: { firstName: string; lastName: string }): string {
  // Handle missing or invalid player name
  if (!playerName || typeof playerName.firstName === 'undefined' || typeof playerName.lastName === 'undefined') {
    return 'unknown-player';
  }
  
  // Handle empty names
  const firstName = playerName.firstName || '';
  const lastName = playerName.lastName || 'unknown';
  
  const fullName = `${firstName} ${lastName}`.trim();
  
  // If we still have an empty string after trimming, return a fallback
  if (!fullName) {
    return 'unknown-player';
  }
  
  return fullName
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
}

/**
 * Generates external ID in format: <team-id>-<player-name-kebab-case>
 */
export function generateExternalId(revSportTeamID: string, playerName: { firstName: string; lastName: string }): string {
  const kebabName = playerNameToKebabCase(playerName);
  return `${revSportTeamID}-${kebabName}`;
}
